import { getBrandName } from 'helpers/utils';
import Container from './Container';

export const PlayerCharacteristics: React.FC<{
  lefthanded?: boolean | null;
  preferred_surface?: string | null;
  racket_brand?: string | null;
  shoes_brand?: string | null;
  clothing_brand?: string | null;
  single_handed?: boolean;
}> = ({ lefthanded, preferred_surface, racket_brand, shoes_brand, clothing_brand, single_handed }) => {
  const itemClassName = 'gap-2 p-3 rounded-xl border border-solid border-neutral-neutral-2 bg-white min-h-20';
  const titleClassName = 'self-stretch text-neutral-neutral-8 text-sm font-medium tracking-normal';
  const contentClassName = 'self-stretch text-neutral-neutral-alpha-12 text-base font-bold tracking-normal';
  if (
    lefthanded === undefined &&
    preferred_surface === undefined &&
    racket_brand === undefined &&
    shoes_brand === undefined &&
    clothing_brand === undefined &&
    single_handed === undefined
  ) {
    return <></>;
  }
  return (
    <Container title='Caratteristiche'>
      <div id='columns' className='grid w-full grid-cols-2 flex-wrap items-start gap-2 self-stretch md:grid-cols-3'>
        {lefthanded !== undefined && (
          <div id='mano' className={itemClassName}>
            <div id='title1' className={titleClassName}>
              Mano preferita
            </div>
            <div id='value1' className={contentClassName}>
              {lefthanded ? 'Sinistra' : 'Destra'}
            </div>
          </div>
        )}
        {preferred_surface && (
          <div id='superficie' className={itemClassName}>
            <div id='title2' className={titleClassName}>
              Superficie preferita
            </div>
            <div id='value2' className={contentClassName}>
              {preferred_surface}
            </div>
          </div>
        )}
        {racket_brand && (
          <div id='racchetta' className={itemClassName}>
            <div id='title3' className={titleClassName}>
              Brand racchetta
            </div>
            <div id='value3' className={contentClassName}>
              {getBrandName('racket', racket_brand)}
            </div>
          </div>
        )}
        {single_handed !== undefined && (
          <div id='rovescio' className={itemClassName}>
            <div id='title4' className={titleClassName}>
              Tipo di rovescio
            </div>
            <div id='value4' className={contentClassName}>
              {single_handed ? 'Rovescio a 1 mano' : 'Rovescio Bimane'}
            </div>
          </div>
        )}
        {shoes_brand && (
          <div id='scarpe' className={itemClassName}>
            <div id='title5' className={titleClassName}>
              Brand scarpe
            </div>
            <div id='value5' className={contentClassName}>
              {getBrandName('shoes', shoes_brand)}
            </div>
          </div>
        )}
        {clothing_brand && (
          <div id='abbigliamento' className={itemClassName}>
            <div id='title6' className={titleClassName}>
              Brand abbigliamento
            </div>
            <div id='value6' className={contentClassName}>
              {getBrandName('clothing', clothing_brand)}
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default PlayerCharacteristics;
